import { FunctionComponent as F, useState, useEffect } from "react";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { IOption } from "@protoplan/types";
import FormControl from "@mui/material/FormControl";

interface Props
{
  id?: string;
  initialValue?: number;
  options: IOption[];
  onBlur?: (value: number) => void;
  onChange?: (value: number) => void;
  disabled?: boolean
}

const EditableDropdown: F<Props> = props =>
{
  const [currentValue, setCurrentValue] = useState(props.initialValue);

  useEffect(() => setCurrentValue(props.initialValue), [props.initialValue]);

  const handleChange = (event: SelectChangeEvent<number>) =>
  {
    const value = Number(event.target.value);

    if(currentValue !== value && props.onChange)
      props.onChange(value);

    setCurrentValue(value);
  };

  const handleBlur = () =>
  {
    if(currentValue && props.onBlur)
      props.onBlur(currentValue);
  };

  return (
    <FormControl fullWidth disabled={(props.disabled === undefined) ? false : props.disabled}>
      {(currentValue !== undefined && props.options.map(o => o.value).includes(currentValue)) ?
        <Select
          id={props.id}
          size='small'
          SelectDisplayProps={{ style: {
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '9px',
            fontSize: 14 } }}
          value={currentValue}
          onChange={handleChange}
          onBlur={handleBlur}>
          {props.options.map((option, index) =>
            <MenuItem
              key={index}
              dense={true}
              sx={{ pt: '3px', pb: '3px', pl: '9px' }}
              value={option.value}>
              {option.label}
            </MenuItem>)}
        </Select> :
        <></>}
    </FormControl>);
};

export default EditableDropdown;
